import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GtagModule } from 'angular-gtag';
import { ReportsComponent } from './components/reports/reports.component';
import { ReportSummaryComponent } from './components/report-summary/report-summary.component';
import { DetailReportComponent } from './components/detail-report/detail-report.component';
import { ReportsButtonComponent } from './components/reports-button/reports-button.component';
import { DrivingDirectionsReportComponent } from './components/driving-directions-report/driving-directions-report.component';
import { StateCountryDistanceReportComponent } from './components/state-country-distance-report/state-country-distance-report.component';
import { RoadTypeDistanceReportComponent } from './components/road-type-distance-report/road-type-distance-report.component';
import { ReportHeaderComponent } from './components/report-header/report-header.component';
import { AddressPipe } from './_helpers/address-pipe';
import { ReportStopComponent } from './components/report-stop/report-stop.component';
import { SharedModule } from '../shared-module/shared.module';
import { TollTypeReportComponent } from './components/reports/toll-type-report/toll-type-report.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ShowDataVersionComponent } from './components/show-data-version/show-data-version.component';
import { PrecisionPipe } from './_helpers/precision-pipe';

@NgModule({
  declarations: [
    ReportsButtonComponent,
    ReportsComponent,
    ReportSummaryComponent,
    ReportHeaderComponent,
    DetailReportComponent,
    DrivingDirectionsReportComponent,
    StateCountryDistanceReportComponent,
    RoadTypeDistanceReportComponent,
    ReportStopComponent,
    AddressPipe,
    PrecisionPipe,
    TollTypeReportComponent,
    ShowDataVersionComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    GtagModule.forRoot({ trackingId: 'G-WG52SHH4TW', trackPageviews: true }),
    TooltipModule.forRoot(),
  ],
  exports: [ReportsButtonComponent],
})
export class ReportsModule {}
